import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const letters = "EDISON".split("");

const Loading = ({ isDarkMode }) => {
  const [loadingDone, setLoadingDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoadingDone(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loadingDone) return null;

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center z-50 ${
        isDarkMode ? "bg-green-800" : "bg-red-200"
      }`}
    >
      <div
        className={`fixed inset-0 flex items-center justify-center z-50 transition-colors duration-300 ${
          isDarkMode ? "bg-black text-white" : "bg-white text-black"
        }`}
      >
        <div className="flex space-x-2 text-[100px] font-bold tracking-widest">
          {letters.map((char, index) => (
            <motion.span
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                delay: index * 0.2,
                duration: 0.6,
                type: "spring",
                stiffness: 100,
              }}
              className="relative"
            >
              <span className="z-10">{char}</span>
              <motion.span
                className={`absolute inset-0 blur-sm opacity-50 ${
                  isDarkMode ? "text-blue-400" : "text-orange-400"
                }`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: index * 0.2 + 0.1, duration: 0.6 }}
              >
                {char}
              </motion.span>
            </motion.span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Loading;
